import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props {
   email: string;
   firstName: string;
   lastName: string;
   country: string;
   company?: string;
   phone?: string;
}

export const RfqContactInfo = ({ email, firstName, lastName, company, country, phone }: Props) => {
   const translate = useTranslations();

   return (
      <Box direction="column" gap="md">
         <Box direction="column" gap="2xs">
            <Typography component="span" variant="body-highlight">
               {translate('page-consumer.request-for-quotation.contact-info.email')}
            </Typography>
            <Box gap="2xs" items="center">
               <Typography component="span" variant="body">
                  {email}
               </Typography>
            </Box>
         </Box>
         <Box direction="column" gap="2xs">
            <Typography component="span" variant="body-highlight">
               {translate('page-consumer.request-for-quotation.contact-info.contact-person')}
            </Typography>
            <Box gap="2xs" items="center">
               <Typography component="span" variant="body">
                  {`${firstName} ${lastName}`}
               </Typography>
            </Box>
         </Box>
         <Box direction="column" gap="2xs">
            <Typography component="span" variant="body-highlight">
               {translate('page-consumer.request-for-quotation.contact-info.company')}
            </Typography>
            <Box gap="2xs" items="center">
               <Typography component="span" variant="body">
                  {company}
               </Typography>
            </Box>
         </Box>
         <Box direction="column" gap="2xs">
            <Typography component="span" variant="body-highlight">
               {translate('page-consumer.request-for-quotation.contact-info.country')}
            </Typography>
            <Box gap="2xs" items="center">
               <Typography component="span" variant="body">
                  {country}
               </Typography>
            </Box>
         </Box>
         {phone && (
            <Box direction="column" gap="2xs">
               <Typography component="span" variant="body-highlight">
                  {translate('page-consumer.request-for-quotation.contact-info.phone')}
               </Typography>
               <Box gap="2xs" items="center">
                  <Typography component="span" variant="body">
                     {phone}
                  </Typography>
               </Box>
            </Box>
         )}
      </Box>
   );
};
